import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class MarkAsShippedBulkForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		var Validator = validatorjs;
		Validator.register(
			'decimalLength',
			value => {
				var decimal = value.toString().split('.')[1];
				if (decimal) {
					return decimal.length <= 2;
				}
				return true;
			},
			'MINIMUMLENGHT'
		);
		Validator.register(
			'numericMinValue',
			value => {
				return 1 / value > 0;
			},
			'NUMERICMINVALUE'
		);
		return {
			fields: [
				'fulfillmentOrders',
				'fulfillmentOrders[].fulfillmentOrderId',
				'fulfillmentOrders[].orderNumber',
				'fulfillmentOrders[].externalShipment',
				'fulfillmentOrders[].trackingNumber',
				'fulfillmentOrders[].shippingCost',
				'fulfillmentOrders[].shippingCostSurcharge',
				'fulfillmentOrders[].assignedWarehouse',
				'fulfillmentOrders[].assignedCarrierService',
				'fulfillmentOrders[].warehouseOptions',
				'fulfillmentOrders[].Id',
			],
			labels: {
				'fulfillmentOrders[].fulfillmentOrderId': 'MARKASSHIPPEDBULKFORM.FO',
				'fulfillmentOrders[].orderNumber': 'MARKASSHIPPEDBULKFORM.MPO',
				'fulfillmentOrders[].externalShipment': 'MARKASSHIPPEDBULKFORM.EXTERNALSHIPMENT',
				'fulfillmentOrders[].trackingNumber': 'MARKASSHIPPEDBULKFORM.TRACKINGNUMBER',
				'fulfillmentOrders[].shippingCost': 'MARKASSHIPPEDBULKFORM.SHIPPINGCOST',
				'fulfillmentOrders[].shippingCostSurcharge': 'MARKASSHIPPEDBULKFORM.SURPLUSCHARGE',
				'fulfillmentOrders[].assignedWarehouse': 'MARKASSHIPPEDBULKFORM.WAREHOUSE',
				'fulfillmentOrders[].assignedCarrierService': 'MARKASSHIPPEDBULKFORM.CARRIERSERVICE',
			},
			rules: {
				'fulfillmentOrders[].trackingNumber': 'required',
				'fulfillmentOrders[].shippingCost': 'required|numeric|decimalLength|numericMinValue',
				'fulfillmentOrders[].shippingCostSurcharge': 'numeric|decimalLength|numericMinValue',
				'fulfillmentOrders[].assignedWarehouse': 'required',
				'fulfillmentOrders[].assignedCarrierService': 'required',
			},
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/MarkAsShippedBulkForm.js